import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routesPC = [
  {
    path: '/',
    component: () => import('@/views/PC/PCHome.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/PC/PCHome.vue')
  },
  {
    path: '/cancelBoutique',
    name: 'cancelBoutique',
    component: () => import('@/views/PC/cancelBoutique.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('@/views/PC/component/pcAgreement.vue')
  }
]
const routesMobile = [
  {
    path: '/',
    component: () => import('@/views/mobile/mobileHome.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/mobile/mobileHome.vue')
  },
  {
    path: '/cancelBoutique',
    name: 'cancelBoutique',
    component: () => import('@/views/mobile/mobileCancelBoutique.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('@/views/mobile/component/mobileAgreement.vue')
  }

]

const isMobile = window.matchMedia('(max-width: 767px)').matches
const routes = isMobile ? routesMobile : routesPC
const router = new VueRouter({ routes })

export default router
